import { LinearGradientProps } from "expo-linear-gradient";

export type LinearGradientConfig = Pick<LinearGradientProps, "colors" | "locations">;

const KYC_GRADIENT_CONFIG = {
    0: "#D2D7FC",
    1: "white",
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const kycGradient: LinearGradientConfig = Object.keys(KYC_GRADIENT_CONFIG)
    .sort((a, b) => Number(a) - Number(b))
    .reduce(
        (result, key) => ({
            locations: [...result.locations, Number(key)],
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            colors: [...result.colors, KYC_GRADIENT_CONFIG[key]],
        }),
        {
            locations: [] as number[],
            colors: [] as string[],
        },
    );
